import { render } from "./SvgCamera.vue?vue&type=template&id=1ef59f31&ts=true"
import script from "./SvgCamera.vue?vue&type=script&lang=ts"
export * from "./SvgCamera.vue?vue&type=script&lang=ts"

import "./SvgCamera.vue?vue&type=style&index=0&id=1ef59f31&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__